import React from "react";
import { TopInfoBar } from "../hooks";
import poor from "../assets/gig/poor.png";
import fair from "../assets/gig/fair.png";
import good from "../assets/gig/good.png";
import veryGood from "../assets/gig/veryGood.png";
import excellent from "../assets/gig/excellent.png";

const sections = [
  {
    id: "poor",
    label: "POOR",
    image: poor,
    text: [
      "This rating may suggest a potential name match with entries in publicly available databases. Extreme caution is advised when interpreting publicly available data, as records may not always be accurate.",
      "If a guest receives a POOR rating, additional verification is required to assess the situation further.",
    ],
    stars: 1,
  },
  {
    id: "fair",
    label: "FAIR",
    image: fair,
    text: ["This rating may suggest that the guest has a history of issues such as property damage, insurance claims, neighbor complaints, or noise disturbances."],
    stars: 2,
  },
  {
    id: "good",
    label: "GOOD",
    image: good,
    text: ["Your Guest is New to Our System. New Guests without a history in our system are initially assigned a GOOD (Default) GIG score, assuming they pass background checks."],
    stars: 3,
  },
  {
    id: "veryGood",
    label: "VERY GOOD",
    image: veryGood,
    text: ["This rating indicates that no adverse behavior patterns have been observed across multiple platforms connected to our systems.", "The guest also has received above-average positive recommendations from hosts."],
    stars: 4,
  },
  {
    id: "excellent",
    label: "EXCELLENT",
    image: excellent,
    text: ["This rating reflects the absence of adverse behavior patterns across multiple platforms integrated with our systems.", "Additionally, the guest has received exceptional 5-star recommendations from hosts."],
    stars: 5,
  },
];

export default function GIG() {
  return (
    <>
      <TopInfoBar />
      <div className="gig-top">
        <div className="gig-top-container">
          <h1>Trustd.ai GIG Score for Short Term Rental - Explained</h1>
          <p>The GIG Score is derived from data provided by Hosts, Property Management Systems (PMS), and Booking Platforms. We collect and process only booking-related, objective, genuine, and measurable information.</p>
          <div className="gig-top-links">
            {sections.map((section) => <a key={section.id} href={`/gig#${section.id}`}>{section.label}</a>)}
          </div>
        </div>
      </div>

      <div className="gigs mt-10">
        {sections.map((section) => (
          <div className={section.id} id={section.id} key={section.id}>
            <img src={section.image} alt={section.label} />
            <div className={`${section.id}-container`}>
              <div className={`${section.id}-inner`}>
                <h4>{section.label}</h4>
                {section.text.map((text) => <p key={text}>{text}</p>)}
                <div className="gig-stars"><span className="stars">{"★".repeat(section.stars)}</span><span className="empty-stars">{"★".repeat(5 - section.stars)}</span></div>
              </div>
            </div>
          </div>
        ))}
        <p className="gig-disclaimer"><strong>Disclaimer:</strong> The GIG Score for Short Term Rental generated by Trustd.ai does not imply or assure the trustworthiness of any individual and should not be solely relied upon as a basis for determining trustworthiness.</p>
      </div>
    </>
  );
}

